/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Subscription { 
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    description?: string;
    id?: number;
    name?: string;
    price?: number;
    type?: Subscription.TypeEnum;
    updateTime?: string;
    updatedByName?: string;
}
export namespace Subscription {
    export type TypeEnum = 'BASIC' | 'PREMIUM' | 'STANDARD';
    export const TypeEnum = {
        Basic: 'BASIC' as TypeEnum,
        Premium: 'PREMIUM' as TypeEnum,
        Standard: 'STANDARD' as TypeEnum
    };
}


